export default {
  BOOKING_SCHEDULE_FILTER: store => {
    return store.bookingScheduleFilter;
  }
};
